module.exports = __webpack_public_path__ + "files/d3e1c0171b0e30ec8235d16a82b51125.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-144x144.png
// module id = 1247
// module chunks = 76